<mat-toolbar class="toolbar">
  <button
    type="button"
    mat-icon-button
    (click)="drawer.toggle()"
    class="button"
  >
    <mat-icon>menu</mat-icon>
  </button>
  <button mat-raised-button type="button" (click)="pointagebuttonClicked()" style="margin-left: 1%; margin-right: 1%; background-color: rgb(31, 202, 255); color: white">
    Pointage
  </button>
  @if (environnement != "") {
    <span class="highlight" >{{ environnement }}</span>
  }

  <span class="spacer"></span>

  <span class="title">ABOPI</span>
  <span class="spacer"></span>
  <button mat-icon-button [matMenuTriggerFor]="menu" class="button">
    <mat-icon>account_circle</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="backToLogin()">
      <mat-icon>power_off</mat-icon>
      <span>Se déconnecter</span>
    </button>
  </mat-menu>
</mat-toolbar>
<mat-drawer-container>
  <mat-drawer #drawer [mode]="modeSidenav" [opened]="openedSidenav">
    <mat-nav-list>
      @for (menu of menus; track $index) {
      <a mat-list-item routerLink="{{ menu.url }}" class="navChose">{{
        menu.nom
      }}</a>
      }
    </mat-nav-list>
    <div class="syncroButton" (click)="syncroClicked()">
      <button mat-raised-button>Lancer une syncro</button>
    </div>
  </mat-drawer>

  <mat-drawer-content>
    <ng-content></ng-content>
  </mat-drawer-content>
</mat-drawer-container>
